import { useEffect } from "react";
import { useMandatorContext } from "@rentablo/theming";
import type { FeatureFlag } from "@rentablo/theming";

export const useFeatureFlag = (flag: FeatureFlag) => {
  const { config } = useMandatorContext();

  useEffect(() => {
    const shouldEnableFlagToggle =
      import.meta.env.VITE_APP_ENVIRONMENT === "development" ||
      import.meta.env.VITE_APP_ENVIRONMENT === "staging";

    if (shouldEnableFlagToggle && typeof window !== "undefined") {
      Object.defineProperty(window, "featureFlags", {
        value: {
          all() {
            return config.featureFlags;
          },

          toggle(flag: FeatureFlag) {
            config.featureFlags[flag] = !config.featureFlags[flag];
            localStorage.setItem(
              "featureFlags",
              JSON.stringify(config.featureFlags)
            );

            return config.featureFlags[flag];
          },
        },
        writable: true,
      });
    }
  }, [config.featureFlags]);

  if (typeof window !== "undefined" && localStorage.getItem("featureFlags")) {
    const localFeatureFlags = JSON.parse(
      localStorage.getItem("featureFlags") as string
    );
    if (flag in localFeatureFlags) {
      return localFeatureFlags[flag];
    }
  }

  return config.featureFlags[flag] || false;
};
